import { useCallback } from "react";
import { useApiClient } from "@/hooks/useApiClient";
import useSWRImmutable from "swr/immutable";
import { extractApiErrorMessage } from "../utils/apiError";

interface IPriceResponse {
  price: number;
}

// 価格取得に失敗した場合に表示するフォールバックメッセージ
const DEFAULT_PRICE_ERROR_MESSAGE = "単価の取得に失敗しました。";

interface IUseCommercialMaskUnlockPriceReturnType {
  unitPrice: number | null;
  isLoading: boolean;
  error: string | null;
  retry: () => void;
}

export const useCommercialMaskUnlockPrice =
  (): IUseCommercialMaskUnlockPriceReturnType => {
    const { apiClient } = useApiClient();

    const fetcher = async (url: string): Promise<IPriceResponse> => {
      const { data } = await apiClient.get<IPriceResponse>(url);
      return data;
    };

    const { data, error, isLoading, mutate } = useSWRImmutable<
      IPriceResponse,
      Error
    >("commercial-reception-book/price", fetcher, {
      shouldRetryOnError: false,
    });

    const retry = useCallback((): void => {
      void mutate();
    }, [mutate]);

    return {
      unitPrice: data?.price ?? null,
      isLoading,
      error: error
        ? extractApiErrorMessage(error) ?? DEFAULT_PRICE_ERROR_MESSAGE
        : null,
      retry,
    };
  };
